/**
 * Which model a meta-agent conversation (Agent of Agents, Concierge) shows in
 * its picker, and which it asks the server for.
 *
 * The server decides what runs (meta_agent_models.resolve_for_conversation:
 * explicit request > the conversation's sticky model > the organization
 * default, within the allowed list) and reports the result as the
 * conversation's `effective_model`. So the client sends a model ONLY when the
 * person picked one here; anything else it sent would become an explicit
 * request that overrides the server — how a new conversation kept running the
 * previous one's Haiku after the default was set to Sonnet (2026-10-04).
 */
export interface MetaAgentModelChoice {
  /** The model the picker shows. '' while nothing is known yet. */
  shown: string;
  /** The model to send with a turn — undefined unless the person picked it here. */
  requested: string | undefined;
}

export function metaAgentModelChoice(
  picked: string | null | undefined,
  /** The server's `effective_model` for this conversation, once it has said. */
  conversationModel: string | null | undefined,
  /** The organization default — shown only until the server has answered. */
  orgDefault: string | null | undefined,
): MetaAgentModelChoice {
  return {
    shown: picked || conversationModel || orgDefault || '',
    requested: picked || undefined,
  };
}
